import { Component } from '@angular/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.sass'],
    standalone: false
})
export class AppComponent {
  title = 'ANU | Neurosciences and Urology System';

  ngOnInit(): void {
    sessionStorage.clear()
  }
}
